import React from 'react';

/** Context: provide access to user object throughout app */

const UserContext = React.createContext();

export default UserContext;
